import { Form, Input, Row, Typography } from 'antd';
import { Fragment, VFC } from 'react';
import { useStore } from 'routes/installation/useStore';
import { mergeDeepRight } from 'rambda';
import { useInstallMeterStepsStore } from 'routes/installation/components/store';
import { FormattedMessage, useIntl } from 'react-intl';
import { HardwaresStepForm } from './slice';
import { HardwaresStepContent as messages } from './messages';

export const HardwaresStepContent: VFC = () => {
  const [form] = Form.useForm();
  const { hardwares, setHardwares } = useStore();
  const { setNextStep } = useInstallMeterStepsStore();
  const intl = useIntl();

  const handleValuesChanged = (
    // WARN: DeepPartial would be 100% correct here
    changedValues: Partial<HardwaresStepForm>,
  ) => {
    setHardwares(prevHardwares => mergeDeepRight(prevHardwares, changedValues.hardwares ?? {}));
  };

  return (
    <>
      <Row justify="center" style={{ marginBottom: '16px' }}>
        <Typography.Text strong>
          <FormattedMessage {...messages.title} />
        </Typography.Text>
      </Row>

      {hardwares.length ? (
        <Form
          form={form}
          id="installMeterHardwaresForm"
          initialValues={{ hardwares }}
          layout="vertical"
          name="basic"
          onFinish={() => setNextStep()}
          onValuesChange={handleValuesChanged}
        >
          {hardwares.map((hardwareFormItem, index) => (
            <Fragment key={hardwareFormItem.id}>
              <Form.Item hidden initialValue={hardwareFormItem.id} name={['hardwares', index, 'id']}>
                <Input allowClear />
              </Form.Item>

              <Form.Item
                label={hardwareFormItem.hardwareName}
                name={['hardwares', index, 'serial_number']}
                rules={[{ required: true, message: intl.formatMessage(messages.serialNumberRequired) }]}
              >
                <Input allowClear />
              </Form.Item>
            </Fragment>
          ))}
        </Form>
      ) : (
        <Row justify="center">
          <Typography.Text>
            <FormattedMessage {...messages.noPairedHardware} />
          </Typography.Text>
        </Row>
      )}
    </>
  );
};
